import axios from 'axios'
import apiUrl from '../../api.config'
const API_URL = apiUrl

class UserService {
    getUserInfo(user_id) {
        return axios.get(API_URL + 'user/get/' + user_id, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    uploadAvatar(formData) {
        return axios.post(API_URL + 'user/uploadAvatar', formData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    updateUserInfo(user_id, user_info) {
        return axios.post(API_URL + 'user/update/' + user_id, user_info, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    addTeacherBySchool(newAccountData, newAccounts) {
        return axios.post(API_URL + 'user/addTeacherBySchool', { newAccountData, newAccounts }, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    getTeacherBySchool() {
        return axios.get(API_URL + 'user/getTeacherBySchool/', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    deleteTeacher(teacher) {
        return axios.delete(API_URL + 'user/deleteTeacher/' + teacher._id, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    updateTeacher(teacher) {
        return axios.post(API_URL + 'user/updateTeacher', teacher, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    addStudentByTeacher(newAccountData, newAccounts) {
        return axios.post(API_URL + 'user/addStudentByTeacher', { newAccountData, newAccounts }, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    getStudentBySchool() {
        return axios.get(API_URL + 'user/getStudentBySchool', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    deleteStudent(student_id) {
        return axios.delete(API_URL + 'user/deleteStudent/' + student_id, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    updateStudent(student) {
        return axios.post(API_URL + 'user/updateStudent', student, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    getSchoolAccountByAdmin() {
        return axios.get(API_URL + 'user/getSchoolAccountByAdmin', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    addSchoolAccountByAdmin(newAccountData, newAccounts) {
        return axios.post(API_URL + 'user/addSchoolAccountByAdmin', { newAccountData, newAccounts }, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    deleteSchoolAccountByAdmin(schoolAccount_id) {
        return axios.delete(API_URL + 'user/deleteSchoolAccountByAdmin/' + schoolAccount_id, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
    updateSchoolAccountByAdmin(schoolAccount) {
        return axios.post(API_URL + 'user/updateSchoolAccountByAdmin', schoolAccount, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}

export default new UserService()